import { useCallback } from "react"

import { DocumentForm } from "@l2r-front/l2r-app-doc"
import { useTranslation } from "@l2r-front/l2r-i18n"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { useEquipmentUpdateDocument } from "../../hooks/mutations/useEquipmentUpdate"

export const EquipmentAddDocumentForm = (props) => {
    const {
        equipmentId,
        onClose,
        onSubmitting,
        onChange,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    const mutation = useEquipmentUpdateDocument(equipmentId, {}, {
        errorSnackbarMessage: t(I18N_NAMESPACE, "containers.equipmentDocumentEditForm.snackbar.error"),
        successSnackbarMessage: t(I18N_NAMESPACE, "containers.equipmentDocumentEditForm.snackbar.success"),
        onSuccess: () => onClose(false),
        onError: () => {
            onSubmitting(false)
        },
    })

    const onSubmit = useCallback((formValues) => {
        const values = {
            document: formValues,
            equipment: equipmentId,
        }
        mutation.mutate(values)
        onSubmitting(true)
    }, [mutation, equipmentId, onSubmitting])

    return <DocumentForm
        isSubmitting={mutation.isPending}
        onSubmit={onSubmit}
        onCancel={() => onClose()}
        onChange={onChange}
    />
}